import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const hatchingTriage = defineConnector({
  identifier: "hatchingTriage",
  name: "Hatching Triage",
  tagLine: "Malware sandbox and detonation",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api.tria.ge/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Follow the official docs at [https://tria.ge/docs/cloud-api/conventions/](https://tria.ge/docs/cloud-api/conventions/) to create an API key for the Hatching Triage API. The API expects that key in an `Authorization: Bearer` header.",
        },
      ],
    },
    {
      title: "Enter your connection details",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: {
            kind: "secrets",
            field: "apiKey",
          },
        },
        {
          kind: "test-url",
          label: "Test URL",
          placeholder: "https://api.tria.ge/",
          helperText:
            "Optional. Set this if you want testing to hit a specific endpoint instead of the default draft URL.",
          urlTarget: {
            kind: "configuration",
            field: "testUrl",
          },
          methodTarget: {
            kind: "configuration",
            field: "testMethod",
          },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ testUrl, testMethod }) => ({
      url: testUrl ?? (() => "https://api.tria.ge/v0/samples")(),
      method: testMethod === "POST" ? "POST" : "GET",
    }),
  },
});
